// NOTE: Apply changes also in api

export default function urlify(raw) {
  const fixed = encodeURI(raw.replace(/[,\\/\s&]/g, '+')).replace(/[+]{2}/g, '+');
  return fixed;
}
